import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'wall',
      d: 'M-3.5,-3h1.5v0.5h-1.5zM-3.5,-2.5h3.5v0.5h-3.5zM-3.5,-2h1.5v0.5h-1.5zM-1.5,-2h2v0.5h-2zM-3.5,-1.5h1v1.5h-1zM-1.5,-1.5h1v0.5h-1zM0,-1.5h0.5v1h-0.5zM-1,-1h0.5v0.5h-0.5zM-1,-0.5h1.5v1.5h-1.5zM0,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'wallShade',
      d: 'M1.5,-7.5h1.5v0.5h-1.5zM1.5,-7h0.5v0.5h-0.5zM2.5,-3h1v0.5h-1zM1,-2.5h2.5v0.5h-2.5zM0.5,-2h1v1h-1zM2.5,-2h1v0.5h-1zM2,-1.5h1.5v0.5h-1.5zM0.5,-1h3v1h-3zM0.5,0h2.5v0.5h-2.5zM0.5,0.5h1.5v0.5h-1.5zM0.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['roofA', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-2,-6h0.5v0.5h-0.5zM-2,-5.5h1v0.5h-1zM-2.5,-5h1.5v0.5h-1.5zM-3,-4.5h2.5v0.5h-2.5zM-3.5,-4h3.5v0.5h-3.5zM-3.5,-3.5h4v0.5h-4zM2.5,-3.5h1v0.5h-1zM-2,-3h3v0.5h-3zM1.5,-3h1v0.5h-1zM0,-2.5h1v0.5h-1z',
    },
    {
      paint: 'roofA',
      d: 'M0,-7h1.5v0.5h-1.5zM-1,-6.5h2.5v0.5h-2.5zM-1.5,-6h3v0.5h-3zM-1,-5.5h2.5v0.5h-2.5zM2.5,-5.5h0.5v0.5h-0.5zM-1,-5h4.5v0.5h-4.5zM-0.5,-4.5h4v0.5h-4zM0,-4h3.5v0.5h-3.5zM0.5,-3.5h2v0.5h-2zM1,-3h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['roofA', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M1.5,-6h0.5v1h-0.5zM3.5,-4h0.5v1h-0.5z',
    },
    {
      paint: 'chimney',
      d: 'M2,-7h0.5v0.5h-0.5zM1.5,-6.5h1v0.5h-1zM2,-6h0.5v1h-0.5zM-2,-2h0.5v0.5h-0.5zM-1.5,-1h0.5v1.5h-0.5zM-3,0h1v0.5h-1zM3,0h0.5v0.5h-0.5zM-2,0.5h1v0.5h-1zM2,0.5h0.5v0.5h-0.5zM-1,1h1v0.5h-1zM1,1h0.5v0.5h-0.5zM0,1.5h0.5v0.5h-0.5z',
    },
    { paint: 'trunk', d: 'M-2.5,-1.5h1v1.5h-1zM-2,0h0.5v0.5h-0.5z' },
    { paint: 'lanternGlow', d: 'M1.5,-2h1v0.5h-1zM-0.5,-1.5h0.5v1h-0.5zM1.5,-1.5h0.5v0.5h-0.5z' },
  ],
  pixels: 201,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'wall',
      d: 'M1,-4.5h0.5v0.5h-0.5zM-3.5,-3h1.5v0.5h-1.5zM-3.5,-2.5h3.5v0.5h-3.5zM-3.5,-2h1.5v0.5h-1.5zM-1.5,-2h2v0.5h-2zM-3.5,-1.5h1v1.5h-1zM-1.5,-1.5h1v0.5h-1zM0,-1.5h0.5v1h-0.5zM-1,-1h0.5v0.5h-0.5zM-1,-0.5h1.5v1.5h-1.5zM0,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'wallShade',
      d: 'M1.5,-7.5h1.5v0.5h-1.5zM1.5,-7h0.5v0.5h-0.5zM2.5,-3h1v0.5h-1zM1,-2.5h2.5v0.5h-2.5zM0.5,-2h1v1h-1zM2.5,-2h1v0.5h-1zM2,-1.5h1.5v0.5h-1.5zM0.5,-1h3v1h-3zM0.5,0h2.5v0.5h-2.5zM0.5,0.5h1.5v0.5h-1.5zM0.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['sail', 0.22],
        ['water', 0.78],
      ],
      d: 'M-2,-6h0.5v0.5h-0.5zM-2,-5.5h1v0.5h-1zM-2.5,-5h1.5v0.5h-1.5zM0,-5h0.5v1h-0.5zM1.5,-5h0.5v1h-0.5zM-3,-4.5h2.5v0.5h-2.5zM-3.5,-4h5v0.5h-5zM-3.5,-3.5h4v0.5h-4zM2.5,-3.5h1v0.5h-1zM-2,-3h3v0.5h-3zM1.5,-3h1v0.5h-1zM0,-2.5h1v0.5h-1z',
    },
    {
      paint: 'water',
      d: 'M0,-7h1.5v0.5h-1.5zM-1,-6.5h2.5v0.5h-2.5zM-1.5,-6h2v0.5h-2zM1,-6h0.5v0.5h-0.5zM-1,-5.5h1.5v0.5h-1.5zM2.5,-5.5h0.5v0.5h-0.5zM-1,-5h1v0.5h-1zM2,-5h1.5v1h-1.5zM-0.5,-4.5h0.5v0.5h-0.5zM1.5,-4h2v0.5h-2zM0.5,-3.5h2v0.5h-2zM1,-3h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.24],
        ['water', 0.76],
      ],
      d: 'M0.5,-6h0.5v0.5h-0.5zM1.5,-6h0.5v0.5h-0.5zM0.5,-5.5h1.5v0.5h-1.5zM0.5,-5h1v0.5h-1zM3.5,-4h0.5v1h-0.5z',
    },
    {
      paint: 'chimney',
      d: 'M2,-7h0.5v0.5h-0.5zM1.5,-6.5h1v0.5h-1zM2,-6h0.5v1h-0.5zM0.5,-4.5h0.5v0.5h-0.5zM-2,-2h0.5v0.5h-0.5zM-1.5,-1h0.5v1.5h-0.5zM-3,0h1v0.5h-1zM3,0h0.5v0.5h-0.5zM-2,0.5h1v0.5h-1zM2,0.5h0.5v0.5h-0.5zM-1,1h1v0.5h-1zM1,1h0.5v0.5h-0.5zM0,1.5h0.5v0.5h-0.5z',
    },
    { paint: 'trunk', d: 'M-2.5,-1.5h1v1.5h-1zM-2,0h0.5v0.5h-0.5z' },
    { paint: 'lanternGlow', d: 'M1.5,-2h1v0.5h-1zM-0.5,-1.5h0.5v1h-0.5zM1.5,-1.5h0.5v0.5h-0.5z' },
  ],
  pixels: 201,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'wall',
      d: 'M-3.5,-3h1v0.5h-1zM-3.5,-2.5h3v0.5h-3zM-3.5,-2h1.5v0.5h-1.5zM-1.5,-2h2v0.5h-2zM-3.5,-1.5h1v0.5h-1zM-1.5,-1.5h1v0.5h-1zM0,-1.5h0.5v1h-0.5zM-3,-1h0.5v0.5h-0.5zM-1,-1h0.5v0.5h-0.5zM-1,-0.5h1.5v1.5h-1.5zM0,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'wallShade',
      d: 'M1.5,-7.5h1.5v0.5h-1.5zM1.5,-7h0.5v0.5h-0.5zM-2.5,-3h0.5v0.5h-0.5zM2.5,-3h1v0.5h-1zM-0.5,-2.5h0.5v0.5h-0.5zM1.5,-2.5h2v0.5h-2zM0.5,-2h1v1h-1zM2.5,-2h1v0.5h-1zM2,-1.5h1.5v0.5h-1.5zM0.5,-1h3v1h-3zM0.5,0h2v0.5h-2zM0.5,0.5h1.5v0.5h-1.5zM0.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['pine', 0.78],
        ['sail', 0.22],
      ],
      d: 'M1.5,-6.5h0.5v1.5h-0.5zM-2,-6h0.5v0.5h-0.5zM-2,-5.5h1v0.5h-1zM-2.5,-5h1.5v0.5h-1.5zM-3,-4.5h2.5v0.5h-2.5zM-3.5,-4h3.5v0.5h-3.5zM-3.5,-3.5h4v0.5h-4zM2.5,-3.5h1v0.5h-1zM-2,-3h3v0.5h-3zM1.5,-3h1v0.5h-1zM0,-2.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'pine',
      d: 'M0,-7h1.5v0.5h-1.5zM-1,-6.5h2.5v0.5h-2.5zM-1.5,-6h3v0.5h-3zM-1,-5.5h2.5v0.5h-2.5zM2.5,-5.5h0.5v0.5h-0.5zM-1,-5h4.5v0.5h-4.5zM-0.5,-4.5h4v0.5h-4zM0,-4h3.5v0.5h-3.5zM0.5,-3.5h2v0.5h-2zM1,-3h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['pine', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M3.5,-4h0.5v1h-0.5z',
    },
    {
      paint: 'chimney',
      d: 'M2,-7h0.5v2h-0.5zM-2,-2h0.5v0.5h-0.5zM-1.5,-1h0.5v1.5h-0.5zM-3,-0.5h0.5v0.5h-0.5zM-2.5,0h0.5v0.5h-0.5zM-2,0.5h1v0.5h-1zM-1,1h1v0.5h-1zM1,1h0.5v0.5h-0.5zM0,1.5h0.5v0.5h-0.5z',
    },
    { paint: 'trunk', d: 'M-2.5,-1.5h1v1.5h-1zM-2,0h0.5v0.5h-0.5z' },
    { paint: 'lanternGlow', d: 'M1.5,-2h1v0.5h-1zM-0.5,-1.5h0.5v1h-0.5zM1.5,-1.5h0.5v0.5h-0.5z' },
    {
      paint: 'manorGarden',
      d: 'M-4,-1.5h0.5v0.5h-0.5zM-4.5,-1h1.5v1h-1.5zM-4,0h1.5v0.5h-1.5zM2.5,0h1.5v0.5h-1.5zM-3.5,0.5h1v0.5h-1zM2,0.5h2v0.5h-2zM1.5,1h2v0.5h-2z',
    },
  ],
  pixels: 218,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
